// extracted by mini-css-extract-plugin
export var actions = "_gp-d";
export var benefitCard = "_gp-a";
export var benefitIcon = "_gp-b";
export var benefitLabel = "_gp-c";
export var benefits = "_gp-9";
export var bodyText = "_gp-8";
export var closeButton = "_gp-2";
export var content = "_gp-3";
export var eyebrow = "_gp-4";
export var heading = "_gp-5";
export var image = "_gp-f";
export var imagePanel = "_gp-e";
export var modal = "_gp-0";
export var shell = "_gp-1";
export var title = "_gp-6";
export var titleOffer = "_gp-7";